<script setup>
import logo from "@/../images/logo.jpg";
import { useLoader } from '@/Stores/useLoader'

const loader = useLoader()
</script>

<template>
  <Transition name="fade">
    <div v-if="loader.isPaginationLoading" class="pagination-loader">
      <img :src="logo" alt="Loading..." class="logo-animation" loading="lazy" />
    </div>
  </Transition>
</template>

<style scoped>
.pagination-loader {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.3); /* Very light white overlay */
  backdrop-filter: none; /* No blur */
  z-index: 40;
  border-radius: 0.5rem;
  pointer-events: none;
}

.logo-animation {
  align-items: center;
  justify-self: center;
  width: 70px;
  height: 70px;
  animation: zoom 1s ease-in-out infinite;
  pointer-events: auto;
  opacity: 0.9; /* Slightly transparent logo */
}

@keyframes zoom {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.15);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>